import { useState, useLayoutEffect } from 'react'

const useReferer = () => {
  const [referer, setReferer] = useState(null)
  const regex =
    /^(dashboard.?|dashboard-v2.?)([a-z0-9]?)+(.pictoaccess+)\.[a-z]{2,5}?$/g

  useLayoutEffect(() => {
    if (referer && referer.match(regex)) {
      setReferer(null)
    }
    setReferer(document.querySelector('body').dataset.referer)
  })

  return referer
}

export default useReferer
